// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialMediaSharing_wrapper__v9pVz","inner":"SocialMediaSharing_inner__RqW+8","someList":"SocialMediaSharing_someList__uFsLG","text":"SocialMediaSharing_text__FRSGT"};